/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cashledger_Collected1Inputs */

const vi_cashledger_collected1 = /** @type {(inputs: Cashledger_Collected1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã thu`)
};

/**

* @param {Cashledger_Collected1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cashledger_collected1 = /** @type {((inputs?: Cashledger_Collected1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cashledger_Collected1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cashledger_collected1(inputs)
});
export { cashledger_collected1 as "cashLedger_collected" }